const normalizeDayOrMonth = (value: number): string | number => (
  value < 10 ? `0${value}` : value
);

const dateToString = (date: Date, monthName = true): string => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  return monthName
    ? `${day}. ${monthToString(month)} ${year}`
    : `${normalizeDayOrMonth(day)}.${normalizeDayOrMonth(month)}.${year}`;
};

const monthToString = (month: number): string | number => {
  switch (month) {
    case 1:
      return 'januára';
    case 2:
      return 'februára';
    case 3:
      return 'marca';
    case 4:
      return 'apríla';
    case 5:
      return 'mája';
    case 6:
      return 'júna';
    case 7:
      return 'júla';
    case 8:
      return 'augusta';
    case 9:
      return 'septembra';
    case 10:
      return 'októbra';
    case 11:
      return 'novembra';
    case 12:
      return 'decembra';
    default:
      return '';
  }
};

export default dateToString;
